import React, { useEffect, useRef, useState } from "react";
import Container from "../../../utils/Container";
import Filtering from "./Filtering";
import HotelListing from "./HotelListing";
import MobileFilter from "./MobileFilter";
import UniversalSearch from "../../../utils/universalSearch/UniversalSearch";
import useSEO from "../../../utils/seo";

const SearchList = () => {
  const [Page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const lastScrollTop = useRef(0);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (
      scrollTop > lastScrollTop.current &&
      scrollTop + clientHeight >= scrollHeight - 10 &&
      !loading
    ) {
      setLoading(true);
      setPage((prev) => prev + 1);
    }

    lastScrollTop.current = scrollTop;
  };

  useEffect(() => {
    if (loading) {
      const timeout = setTimeout(() => setLoading(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [loading]);
  useSEO({
    title: "Search Hotels | Dhoorbin.com",
    description:
      "Your travel companion for booking hotels, tours, and experiences worldwide.",
    image: `${window.location.origin}/images/banner.png`,
    url: "https://dhoorbin.com",
    canonical: "https://dhoorbin.com",
    keywords: "travel, hotel, tour, booking",
    publisher: "Dhoorbin",
    robots: "index, follow",
    lang: "en",
  });
  return (
    <>
      <div className="bg-white sticky top-0 z-50 py-3 lg:block hidden">
        <Container>
          <UniversalSearch />
        </Container>
      </div>
      <div className="w-full h-full py-1 lg:py-10 bg-[#ebf0f4] ">
        <Container>
          <MobileFilter />

          <div className="flex-none lg:flex gap-8 py-2">
            <div className="hidden lg:block ">
              <Filtering />
            </div>
            <div className="flex-1 w-full mb-20 lg:mb-0">
              <HotelListing />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default SearchList;
